
  <!-- Sidebar -->
  <app-sidebar></app-sidebar>
  <div >
    <app-header></app-header> 
    <!-- Page Content -->
    <div id="content">
      <app-ausencia-temporaria></app-ausencia-temporaria> 
    </div>
    <app-footer></app-footer>
</div>